import { ScannedReturnShipping } from '../../models';
import { Option } from '@/components/inputs/AutocompleteInput';
import { useState, useEffect, useCallback } from 'react';

const getFromStorage = <T>(key: string, defaultValue: T): T => {
  try {
    const saved = localStorage.getItem(key);
    return saved ? (JSON.parse(saved) as T) : defaultValue;
  } catch {
    return defaultValue;
  }
};

export const useScannerStorage = () => {
  const STORAGE_KEY_ITEMS = 'returns_scanner_items';
  const STORAGE_KEY_DRIVER = 'returns_scanner_driver';

  const [driver, setDriver] = useState<Option | null>(() => 
    getFromStorage<Option | null>(STORAGE_KEY_DRIVER, null)
  );
  
  const [scannedShippings, setScannedShippings] = useState<ScannedReturnShipping[]>(() => 
    getFromStorage<ScannedReturnShipping[]>(STORAGE_KEY_ITEMS, [])
  );

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY_ITEMS, JSON.stringify(scannedShippings));
    localStorage.setItem(STORAGE_KEY_DRIVER, JSON.stringify(driver));
  }, [scannedShippings, driver]);

  const clearStorage = useCallback(() => {
    setScannedShippings([]);
    setDriver(null);
    localStorage.removeItem(STORAGE_KEY_ITEMS);
    localStorage.removeItem(STORAGE_KEY_DRIVER);
  }, []);

  return {
    driver,
    setDriver,
    scannedShippings,
    setScannedShippings,
    clearStorage,
  };
};
